export class Technique {
	constructor(
		public id: number = 0,
		public value: string = '',
		public description: string = ''
	) {}
}
